export default "__VITE_ASSET__e4uTjLyp__"